export const abortController = (() => {
  let controller = new AbortController()
  let signal = controller.signal
  const abortPendingRequest = () => {
    controller.abort()
    controller = new AbortController()
    signal = controller.signal
  }
  const getSignalToken = () => signal

  return {
    abortPendingRequest,
    getSignalToken,
  }
})()
